module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "side-bottom-list list-reset flex flex-wrap items-start"
  }, _vm._l((_vm.data), function(item, idx) {
    return _c('li', {
      key: item.id,
      staticClass: "col-6 flex items-start justify-between"
    }, [_c('div', {
      staticClass: "col-5 primary-img relative",
      attrs: {
        "data-ratio": "16/9"
      }
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "fit",
      attrs: {
        "src": _vm.shift(item.o_pic_list[0])
      }
    })])]), _c('div', {
      staticClass: "col-7 primary-info px1"
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "item-title fs-14",
      attrs: {
        "title": item.title,
        "data-clamp": "3"
      }
    }, [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: "sub col-12"
    }, [_vm._v(_vm._s(item.pub_source)), _c('span', {
      staticClass: "px1"
    }, [_vm._v("|")]), _vm._v(_vm._s(_vm.formatUtc(item.pub_utc)))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27aac4e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sideBottomList.vue
// module id = 985
// module chunks = 1